import { Helmet } from "react-helmet-async"
import { Grid } from "src/components"
import BaseComponent from "src/core/base.component"
import { translate } from "src/i18n/tHelper"
import KurumMailGonderimAyarlariAramaKriterleri from "./AramaKriterleri"
import KurumMailGonderimAyarlariListe from "./Liste"
import { useAppSelector } from "src/store"
import KurumMailGonderimAyarEkle from "./Ekle"


interface IKurumMailGonderimAyarlariProps { }
const translatePath = "pages|KurumMailGonderimAyarlari"
const KurumMailGonderimAyarlari = (props: IKurumMailGonderimAyarlariProps): JSX.Element => {

    const state = useAppSelector(state => state.kurumMailGonderimAyarlari);

    return (

        <>
            <Helmet><title>{translate(translatePath, "Kurum Mail Gönderim Ayarları")}</title></Helmet>
            <BaseComponent>
                {state.open && <KurumMailGonderimAyarEkle />}
                <Grid container>
                    <Grid item>
                        <KurumMailGonderimAyarlariAramaKriterleri />
                    </Grid>
                    <Grid item>
                        <KurumMailGonderimAyarlariListe />
                    </Grid>
                </Grid>
            </BaseComponent>

        </>
    )
}

export default KurumMailGonderimAyarlari